import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'sms-opted-out-warning:popup-title': {
    id: 'sms-opted-out-warning:popup-title',
    defaultMessage: 'Phone number currently blocked',
    description: 'Blocked phone number: popup title',
  },
  'sms-opted-out-warning:popup-description': {
    id: 'sms-opted-out-warning:popup-description',
    defaultMessage:
      'Your phone number is blocked with the provider. Please text {smsOptInKeyword} to {smsOptInPhoneNumber} to unblock your number.',
    description: 'Blocked phone number: popup text',
  },
  'sms-opted-out-warning:popup-confirm-button-text': {
    id: 'sms-opted-out-warning:popup-confirm-button-text',
    defaultMessage: 'Text {smsOptInKeyword} to {smsOptInPhoneNumber}',
    description: 'Blocked phone number: popup confirm button text',
  },
});
